import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import logo from '../../assets/img/reactlogo.png';
import logoSmall from '../../assets/img/logoSmall.png';
import '../../assets/css/flaticon.css';
import $ from 'jquery';

// Attach jQuery to the global window object
window.jQuery = $;
window.$ = $;

function FrontLayout() {
  const [isVisible, setIsVisible] = React.useState(false);
  return (
    <>
      {/* <div class="preloader">
        <div class="loader">
          <div class="shadow"></div>
          <div class="box"></div>
        </div>
      </div> */}
      <div class="navbar-area">
        <div class="main-responsive-nav">
          <div class="container">
            <div class="main-responsive-menu mean-container">
              <div class="mean-bar">
                <Link class="meanmenu-reveal" onClick={(e) => setIsVisible(!isVisible)}>
                  <span><span><span></span></span></span>
                </Link>
                <nav class="mean-nav">
                  <ul class="navbar-nav" style={{ display: isVisible ? "block" : "none" }}>
                    <li class="nav-item">
                      <Link to="/" class="nav-link active" onClick={(e) => setIsVisible(false)}>
                        Home
                      </Link>
                    </li>
                    <li class="nav-item">
                      <Link to="/about" class="nav-link" onClick={(e) => setIsVisible(false)}>
                        About Us
                      </Link>
                    </li>
                    <li class="nav-item">
                      <Link to="/team" class="nav-link" onClick={(e) => setIsVisible(false)}>
                        Team
                      </Link>
                    </li>
                    <li class="nav-item">
                      <Link to="/services" class="nav-link" onClick={(e) => setIsVisible(false)}>
                        Services
                      </Link>
                    </li>
                    <li class="nav-item mean-last">
                      <Link to="/contact" class="nav-link" onClick={(e) => setIsVisible(false)}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="logo">
                <Link to={"/"}>
                  <img src={logo} class="black-logo" alt="image" />
                  {/* <img src={logo} class="white-logo" alt="image" /> */}
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div class="main-navbar">
          <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
              <Link class="navbar-brand" to={"/"}>
                <img src={logo} class="black-logo" alt="image" />
                {/* <img src={logo} class="white-logo" alt="image" /> */}
              </Link>

              <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <Link to={"/"} class="nav-link">
                      Home
                    </Link>
                  </li>

                  <li class="nav-item">
                    <Link to={"/about"} class="nav-link">
                      About us
                    </Link>
                  </li>

                  <li class="nav-item">
                    <Link to={"/team"} class="nav-link">
                      Team
                    </Link>
                  </li>

                  <li class="nav-item">
                    <Link to={"/services"} class="nav-link">
                      Services
                    </Link>
                  </li>

                  <li class="nav-item">
                    <Link to={"/contact"} class="nav-link">
                      Contact
                    </Link>
                  </li>
                </ul>

                <div class="others-options d-flex align-items-center">
                  {/* <div class="option-item">
                    <form class="search-box">
                      <input type="text" class="form-control" placeholder="Search for.." />
                      <button type="submit"><i class="flaticon-loupe"></i></button>
                    </form>
                  </div> */}

                  <div class="option-item">
                    <Link to={"/login"} class="default-btn">Login</Link>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <main>
        <Outlet />
      </main>
      <section class="footer-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="single-footer-widget">
                <div class="footer-logo">
                  <h2><Link to={"/"}><img src={logo} /></Link></h2>

                  <p>Go cashless with Pargati app. You can pay mobile, gas, electricity, DTH, broadband bills and recharges.</p>

                  <ul class="social">
                    <li>
                      <a href="#" class="facebook" target="_blank">
                        <i class='bx bxl-facebook'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="twitter" target="_blank">
                        <i class='bx bxl-twitter'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="pinterest" target="_blank">
                        <i class='bx bxl-instagram'></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="linkedin" target="_blank">
                        <i class='bx bxl-linkedin'></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-sm-6">
              <div class="single-footer-widget">
                <h3>Contact</h3>

                <ul class="footer-contact-info">
                  <li>
                    <i class='bx bxs-phone'></i>
                    <span>Phone</span>
                    <a href="tel:01724049681">01724049681</a>
                  </li>
                  <li>
                    <i class='bx bx-envelope'></i>
                    <span>Email</span>
                    <a href="mailto:support@pargationline.com"><span>support@pargationline.com</span></a>
                  </li>
                  <li>
                    <i class='bx bx-map'></i>
                    <span>Address</span>
                    PARGATI ONLINE SERVICE PRIVATE LIMITED<br />
                    SCO 832, 2nd Floor, NAC Manimajra, Chandigarh 160101
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-3 col-sm-6">
              <div class="single-footer-widget pl-5">
                <h3>Quick Links</h3>

                <ul class="quick-links">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/team">Team</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/bazaar">Pargati Bazaar</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-3 col-sm-6">
              <div class="single-footer-widget">
                <h3>Help & guidance</h3>

                <ul class="quick-links">
                  <li>
                    <Link to="/termAndConditions">Term & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacyPolicy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/refundPolicy">Refund Policy</Link>
                  </li>
                  <li>
                    <Link to="/returnPolicy">Return Policy</Link>
                  </li>
                  <li>
                    <Link to="/shippingPolicy">Shipping Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="copyright-area">
        <div class="container">
          <div class="copyright-area-content">
            <p>©2025 Pargati Online Services Pvt Ltd. All Rights Reserved. </p>
          </div>
        </div>
      </div>
      <div class="go-top">
        <i class='bx bx-up-arrow-alt'></i>
      </div>
    </>
  );
}

export default FrontLayout;
